/*! License details at fancyapps.com/license */
var t = function t(_t) {
  return "object" == typeof _t && null !== _t && _t.constructor === Object && "[object Object]" === Object.prototype.toString.call(_t);
};
export { t as isPlainObject };